import { render } from "./DatePicker.vue?vue&type=template&id=f941fd72"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"
script.render = render

export default script